import { USER_ROLE } from '@/models/comment.model';
import ImageModel from '@/models/image.model';

export default interface QuestionModel {
  id: string;
  badge: USER_ROLE;
  user: QuestionUserModel;
  createdAt: number;
  content: string;
  replies: QuestionModel[] | null;
  status: QUESTION_STATUS;
}

export interface QuestionUserModel {
  id: string;
  avatar: ImageModel;
  displayName: string;
}

export enum QUESTION_STATUS {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
}
